import React, { useEffect } from 'react'
import TvActivationReverse from './TvActivationReverse'
import { useSelector } from 'react-redux';
import LinkTvApp from './LinkTvApp';

const TVAppIndex = () => {
  const projectInfo=useSelector((state)=>state?.projectInfo?.value);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);

  useEffect(()=> {
    window.scroll(0,0)

  },[])
  return (
    <div className={`tvAppIndex ${isRTL ? "rtl" : ""}`}>
        {projectInfo?.projectConfig?.config?.REVERSE_TV_CODE_FLOW === "true"?(
            <TvActivationReverse/>

        ):(
            <LinkTvApp/>
        )
    }
    </div>
  )
}

export default TVAppIndex